// src/scripts/carousel.js

class Carousel3D {
    constructor() {
        this.track = document.querySelector('.carousel-track');
        this.cards = Array.from(document.querySelectorAll('.carousel-card'));
        this.dotsContainer = document.querySelector('.carousel-dots');
        this.prevBtn = document.querySelector('.carousel-btn-prev');
        this.nextBtn = document.querySelector('.carousel-btn-next');
        
        // Sécurité : si un élément manque, on arrête tout
        if (!this.track || !this.dotsContainer || !this.prevBtn || !this.nextBtn) {
            console.warn("Carousel3D: Éléments manquants dans le DOM.");
            return;
        }

        this.currentIndex = 0;
        this.cardWidth = 0;
        this.isDragging = false;
        this.startPos = 0;
        this.currentTranslate = 0;
        this.prevTranslate = 0;
        this.dots = [];
        this.autoPlayInterval = null;
        
        this.init();
    }
    
    init() {
        this.dotsContainer.innerHTML = ''; 
        
        this.createDots();
        this.updateCardWidth();
        this.updateCarousel();
        this.attachEvents();
        this.startAutoPlay();
    }
    
    createDots() {
        this.cards.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.classList.add('carousel-dot');
            if (index === 0) dot.classList.add('active');
            
            // Correction : Utilisation d'une fonction fléchée pour conserver 'this'
            dot.addEventListener('click', () => this.goToSlide(index));
            this.dotsContainer.appendChild(dot);
            this.dots.push(dot); // Ajoute le point au tableau local
        });
    }
    
    updateCardWidth() {
        if(this.cards.length > 0) {
            this.cardWidth = this.cards[0].offsetWidth + 32;
        }
    }
    
    attachEvents() {
        // Nettoyage des événements si on recrée le carrousel
        this.prevBtn.replaceWith(this.prevBtn.cloneNode(true));
        this.nextBtn.replaceWith(this.nextBtn.cloneNode(true));
        
        // Récupération des nouveaux boutons sans event listeners
        this.prevBtn = document.querySelector('.carousel-btn-prev');
        this.nextBtn = document.querySelector('.carousel-btn-next');

        this.prevBtn.addEventListener('click', () => this.prev());
        this.nextBtn.addEventListener('click', () => this.next());
        
        // Note: Pour une implémentation React pure, le drag & drop devrait idéalement 
        // être géré par des librairies ou refondu en hooks, mais on garde la logique classique ici.
    }
    
    next() {
        if(this.cards.length === 0) return;
        this.currentIndex = (this.currentIndex + 1) % this.cards.length;
        this.updateCarousel();
        this.resetAutoPlay();
    }
    
    prev() {
        if(this.cards.length === 0) return;
        this.currentIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
        this.updateCarousel();
        this.resetAutoPlay();
    }
    
    goToSlide(index) {
        this.currentIndex = index;
        this.updateCarousel();
        this.resetAutoPlay();
    }
    
    updateCarousel() {
        this.cards.forEach((card, index) => {
            const offset = index - this.currentIndex;
            const absOffset = Math.abs(offset);
            
            // Animation 3D
            card.style.transform = `
                translateX(${offset * 100}%)
                translateZ(${-absOffset * 200}px)
                rotateY(${offset * -15}deg)
                scale(${1 - absOffset * 0.2})
            `;
            
            card.style.opacity = absOffset === 0 ? 1 : 0.5;
            card.style.zIndex = 10 - absOffset;
            
            if(index === this.currentIndex) {
                card.classList.add('active');
            } else {
                card.classList.remove('active');
            }
        });
        
        this.dots.forEach((dot, index) => {
            if(index === this.currentIndex) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
        
        this.prevTranslate = -this.currentIndex * this.cardWidth;
    }
    
    startAutoPlay() {
        this.stopAutoPlay(); // Sécurité
        this.autoPlayInterval = setInterval(() => this.next(), 4000);
    }
    
    stopAutoPlay() {
        if(this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
            this.autoPlayInterval = null;
        }
    }
    
    resetAutoPlay() {
        this.startAutoPlay();
    }

    // Méthode de nettoyage très importante pour React
    destroy() {
        this.stopAutoPlay();
        // On pourrait nettoyer plus d'écouteurs ici si nécessaire
    }
}

// C'est CETTE fonction que React va importer et lancer
export function initCarousel() {
    return new Carousel3D();
}